import { render } from "./ExternalLinkModal.vue?vue&type=template&id=ab29f0fe"
import script from "./ExternalLinkModal.vue?vue&type=script&lang=js"
export * from "./ExternalLinkModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/MearnsGill/Sites/ICoTA/icota-europe.localhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__